import { render, staticRenderFns } from "./BankData.vue?vue&type=template&id=d9a87fc8&scoped=true&"
import script from "./BankData.vue?vue&type=script&lang=js&"
export * from "./BankData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a87fc8",
  null
  
)

export default component.exports